import {toURL} from '@homeaway/search-url-parser';

function redirectToPinnedSERP(listing, system, tripDetails, pinnedPropertyLabel = '') {
    const url = toURL(
        {
            arrival: tripDetails.newArriveDate,
            departure: tripDetails.newDepartDate,
            adultsCount: tripDetails.newAdults,
            childrenCount: tripDetails.newChildren,
            petIncluded: tripDetails.newPets,
            pinnedPropertyListing: listing.spu,
            pinnedPropertyLabel
        },
        {
            siteContext: window.__SITE_CONTEXT__
        }
    );

    window.location.href = url;
}

export default redirectToPinnedSERP;
